import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';





@Injectable()
export class MisselaniaService {
    removerAcentos(_str:FormControl):void{
        console.log("#")
        let str:string=_str.value+"";
        str=((str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")))
        .replace(/\ /g,"_")
        .toLowerCase();
        _str.setValue(str);

        _str.setValue(str);
    } 
}